import React from "react";
import {
	Container, Grid, Box,
	Typography, Paper, Button,
	List, ListItem, ListItemText, ListItemIcon
} from "@mui/material";
import RedeemIcon from '@mui/icons-material/Redeem';
import { makeStyles } from "tss-react/mui";

import { SiteAuthHeader } from "../../components/AuthHeader";
import { SiteRouterLink } from "../../../components/RouterLink";
import { SiteRouterButtonLink } from "../../../components/RouterButtonLink";
import { useI18n } from "./locales";
import { Helmet } from "react-helmet-async";
import { useUrlWithNext } from "../../utils";

const useStyles = makeStyles()(() => ({
	main: {
		
	},
	logo: {
		display: "block",
		//margin: "0 auto 24px",
		width: 48,
	}
}))

export function AuthRoot() {
	const { classes } = useStyles();
	const { t } = useI18n();
	const authFeatures = [
		// {
		// 	title: t('benefits.item1')
		// },
		{
			title: t('benefits.item2')
		},
		{
			title: t('benefits.item3')
		},
	];
	const loginURL = useUrlWithNext('/auth/login');
	const registerURL = useUrlWithNext('/auth/register');
	return (
		<>
			<Helmet>
				<title>{t('Account management')} — Haohan</title>
			</Helmet>
			<SiteAuthHeader/>
			<main>
				<Container maxWidth='md' sx={{py: 6}}>
					<Grid container spacing={4} direction={{xs: 'column-reverse', md: 'row'}}>
						<Grid item md={7} sm={7} xs={12} margin='0 auto'>
							<Typography
								fontWeight={800}
								gutterBottom
								variant="h5"
							>
								{t('actions.Sign in Haohan.io account')}
							</Typography>
							<Typography
								// color="grey"
								mb={2}
								variant="body1"
							>
								{t('Discover more possibilities with a personal account')}.
								{t('Create it from scratch or sign in existing one')}
							</Typography>
							<Typography
								//textAlign="center"
								mb={.5}
								variant="subtitle1"
							>
								{t('After sign in into your account, you will be able to')}
							</Typography>
							<List>
								{authFeatures.map((feature, idx) => (
									<ListItem key={idx} sx={{px: 0}}>
										<ListItemIcon sx={{minWidth: 48}}>
											<RedeemIcon color='primary' />
										</ListItemIcon>
										<ListItemText>
											{feature.title}
										</ListItemText>
									</ListItem>
								))}
							</List>
						</Grid>
						<Grid
							item md={5} sm={7} xs={12}
							sx={{
								margin: '0 auto',
							}}
						>
							<Paper sx={{
								py: 3,
								px: 2,
								mt: {
									md: 6,
									xs: 0
								}
							}}>
								{/*<Box display='flex' justifyItems='center'>
									<img
										className={classes.logo}
										src="/dist/img/logo.svg"
									/>
								</Box>*/}
								<Typography
									fontWeight={500}
									textAlign="center"
									sx={{mb: 2}}
									variant="h6"
								>
									{t('actions.Sign in Haohan.io')}
								</Typography>

								<SiteRouterButtonLink
									fullWidth
									color="info"
									variant="outlined"
									sx={{mb: 2}}
									to={loginURL}>
									{t('actions.Sign in account')}
								</SiteRouterButtonLink>
								<SiteRouterButtonLink
									color="info"
									fullWidth
									to={registerURL}
									variant="contained"
									sx={{mb: 2}}
								>
									{t('actions.Create account')}
								</SiteRouterButtonLink>
								<Typography variant="subtitle2" color="textSecondary" textAlign="center">
									{t('After sign in in, you will be redirected to the original page')}
								</Typography>
							</Paper>
						</Grid>
					</Grid>
				</Container>
			</main>
		</>
	);
}
